export default __webpack_public_path__ + "admin-map-800-47c01a33413066d8e3b17bc3ac958c20.webp";